import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import { resolveAdminCrumbs } from './resolveAdminCrumbs.js';

export default function AdminBreadcrumbs() {
  const { t } = useLanguage();
  const location = useLocation();
  const crumbs = resolveAdminCrumbs(location.pathname, t);
  return (
    <nav className="flex flex-wrap items-center gap-1 px-4 pt-3 text-xs leading-relaxed text-slate-500">
      {crumbs.map((c, i) => (
        <React.Fragment key={c.id}>
          {i > 0 ? <span>/</span> : null}
          {i === crumbs.length - 1 ? (
            <span className="font-medium text-slate-700">{c.label}</span>
          ) : (
            <Link to={c.path} className="hover:text-indigo-600">
              {c.label}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
